export function getExternalNodesUrl(): string {
  const base = process.env.galaswapLinkUrl || 'https://connect.gala.com';
  return `${base.replace(/\/$/, '')}/nodes`;
}
